import { useSelector } from "src/redux/store";
import { PATH_DASHBOARD } from "src/routes/paths";

const useDefaultQuery = () => {
  let documentQuery = useSelector(
    (state: any) => state.defaultQuery.documentList
  );

  let defaultQuery = documentQuery.query;
  const path_ = PATH_DASHBOARD.general.documents.root;
  const path = defaultQuery ? `${path_}?${defaultQuery}` : path_;

  const comparePaths = (path1: string | undefined, path2: string) => {
    if (!path1 || !path2) return false;
    const url1 = new URL(window.location.origin + path1);
    const url2 = new URL(window.location.origin + path2);
    let result = url1.pathname === url2.pathname;
    return result;
  };

  return { path, comparePaths };
};
export default useDefaultQuery;
